import { PureComponent } from 'react'
import styled from 'glamorous'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { graphql } from 'react-apollo'
import { withRouter } from 'react-router-dom'
import { compose } from 'react-apollo'

import { client } from 'config'
import { $, getLocationQuery, getUrlSearch, getError } from 'utils'
import { withConsumer } from 'store'
import { Icon, InfoRow, Loader, EditableName, Tooltip, HeaderRow } from 'components'
import { TOKENS as query, TOKEN, UpdateTokenMutation, RemoveTokenMutation } from 'queries'


const Container = styled.div({
  position: 'relative',
  width: '100%',
  height: '100%',
  overflow: 'hidden'
})

const DetailsInfoContainer = styled.div({
  position: 'absolute',
  width: '100%',
  height: '100%',
}, 'detailsInfoContainer')

const DetailsInfoContainerInner = styled(PerfectScrollbar)({
  position: 'relative',
}, 'scrollableContainer')

const Block = styled.div({
  padding: 30,
  borderBottom: '1px solid var(--borderColor)',
})

class DetailsInfo extends PureComponent {

  updateTokenData = (value) => {
    const { updateToken, token, match } = this.props
    return updateToken({
      variables: {
        tokenId: token.uuid,
        tokenData: value
      },
      update: (proxy, { data: { updateToken } }) => {
        if (updateToken.ok) {
          const variables = { uuid: match.params.id }
          const data = proxy.readQuery({ query: TOKEN, variables })
          data.token.tokenData = value
          proxy.writeQuery({ query: TOKEN, data, variables })
        }
      }
    })
      .catch(error => this.props.setErrorMessage(getError(error)))
  }

  getUpdatedVariables = () => {
    let variables = getVariables(getLocationQuery(this.props.location))
    const cacheData = client.cache.readQuery({ query, variables })
    if ((cacheData.account.tokens.count - 1) % variables.limit === 0) {
      if (cacheData.account.tokens.count === 1) {
        variables = getVariables()
      } else {
        variables.offset -= 1
      }
    }
    return variables
  }

  removeToken = () => {
    const variables = this.getUpdatedVariables()
    return this.props.removeToken({
      variables: { tokenId: this.props.token.uuid },
      refetchQueries: [{
        query,
        variables,
      }]
    })
    .then((response) => {
      if (response.data.removeToken.ok) {
        const variables = this.getUpdatedVariables()
        this.props.history.push({
          pathname: '/tokens',
          search: getUrlSearch(variables),
        })
      }
    })
    .catch(error => this.props.setErrorMessage(getError(error)))
  }


  render() {
    const {token: {uuid, tokenData } } = this.props
    return (
      $(DetailsInfoContainer,
        $(DetailsInfoContainerInner,
          $(Block,
            $(HeaderRow, { label: $(EditableName, { key: uuid, value: tokenData, onUpdate: this.updateTokenData}) },
              $(Tooltip, {tip: 'Remove token'},
                $(Icon, {
                  type: 'delete',
                  onClick: this.removeToken
                })
              )
            ),
            $(InfoRow, {name: 'ID:', value: uuid}),
            $(InfoRow, {name: 'Title:', value: tokenData})
          )
        )
      )
    )
  }
}

export class DetailsPage extends PureComponent {

  render () {
    const { data: { loading, token } } = this.props
    if (loading && !token) return $(Loader)

    return (
      $(Container,
        $(DetailsInfo, {
          ...this.props, token
        })
      )
    )
  }
}

export default withRouter(
  compose(
    graphql(UpdateTokenMutation, { name: 'updateToken' }),
    graphql(RemoveTokenMutation, {name: 'removeToken'}),
    graphql(TOKEN, {
        options: props => ({
          fetchPolicy: 'cache-and-network',
          variables: {
            uuid: props.match.params.id
          }
        })
    })
  )(withConsumer(DetailsPage, '/tokens'))
)

const getVariables = (queryParams = {}) => ({
  limit: +queryParams.limit || 10,
  offset: +queryParams.offset || 1,
})



// WEBPACK FOOTER //
// ./src/pages/Tokens/DetailsPage.js